let jQuery, dwpCommentValidationNotices;
// let console;

(function ($, document) {
	$(document).ready(function () {
		/**
		 * comment object containing the needed DOM elements
		 *
		 * @type {Object} form elements that will be used in the code
		 */
		const comment = {
			name: {
				input: $('#commentform #author'),
				container: $('.comment-form-author'),
			},
			email: {
				input: $('#commentform #email'),
				container: $('.comment-form-email'),
			},
			text: {
				input: $('#commentform #comment'),
				container: $('.comment-form-comment'),
			},
			submitButton: {
				button: $('body #commentform #submit'),
				container: $('.form-submit'),
			},
		};

		/**
		 * A wrapper function to get the entire message object
		 * dwpCommentValidationNotices.
		 *
		 * @return {Object} dwpCommentValidationNotices
		 */
		const getMessages = () => dwpCommentValidationNotices;

		/**
		 * A wrapper function to retrieve individual messages
		 * from dwpCommentValidationNotices.
		 *
		 * @param {string} input   string indicating which form element the message is for
		 * @param {string} message short string indicating which message to return
		 * @return {string}         translated message from dwpCommentValidationNotices
		 */
		const getMessage = (input, message) => {
			if (!input && !message) {
				return '';
			}
			const messages = getMessages();
			if ('name' === input) {
				if ('required' === message) {
					return messages.nameRequired;
				}
				return '';
			}
			if ('email' === input) {
				if ('required' === message) {
					return messages.emailRequired;
				}
				if ('invalid' === message) {
					return messages.emailInvalid;
				}
				return '';
			}
			if ('comment' === input) {
				if ('required' === message) {
					return messages.commentTextRequired;
				}
				if ('too short' === message) {
					return messages.commentTooShort;
				}
				return '';
			}
			if ('form' === input) {
				if ('incomplete' === message) {
					return messages.pleaseFillForm;
				}
				return '';
			}
		};

		/**
		 * A wrapper over the (DOM) elements in which messages are displayed
		 * it filles the messages near the element to which the error belongs.
		 *
		 * input points to the element:
		 * 'name', 'email', 'comment' or 'form'
		 *
		 * @param {string} input   indicates which form element the message is for
		 * @param {string} message the message that is to be displayed
		 * @return {void}
		 */
		const setMessage = (input, message) => {
			if (!input) {
				return;
			}
			if ('name' === input) {
				$('#nameNotice').text(message);
				return;
			}
			if ('email' === input) {
				$('#emailNotice').text(message);
				return;
			}
			if ('comment' === input) {
				$('#commentNotice').text(message);
				return;
			}
			if ('form' === input) {
				$('#pleaseFillForm').text(message);
			}
		};

		/**
		 * Disable comment form submit button.
		 *
		 * @param {Object} button submit button element
		 * @return {void}
		 */
		const disableButton = (button) => button.attr('disabled', 'disabled');

		/**
		 * Enable comment form submit button.
		 *
		 * @param {Object} button submit button element
		 * @return {void}
		 */
		const enableButton = (button) => button.removeAttr('disabled');

		/**
		 * Determine if an input form field is empty
		 *
		 * @param {Object} input form input element
		 * @return {boolean} true if input is empty, false if not empty
		 */
		const isEmptyInput = (input) => {
			if ('' === input.val().replace(/ /g, '')) {
				return true;
			}
			return false;
		};

		/**
		 * Check if input has a valid format for e-mailaddresses.
		 *
		 * @param {Object} email email address form input element
		 * @return {boolean} true if emailaddress has a valid syntax, false if not
		 */
		const isValidEmailAddressFormat = (email) => {
			const regex =
				/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
			if (regex.test(email.val().trim())) {
				return true;
			}
			return false;
		};

		/**
		 * Determine the length of the comment exluding spaces.
		 *
		 * @param {Object} commentText text element with comment
		 * @return {number} length of comment excluding spaces
		 */
		const commentTextLength = (commentText) => {
			return commentText.val().replace(/ /g, '').length;
		};

		/**
		 * Validate the comment length.
		 * Returns false when comment has less than 15 characters excluding spaces.
		 *
		 * @param {Object} commentText element with the comment content
		 * @return {boolean} true when comment contains at least 15 non-space characters
		 */
		const isCommentTextLongEnough = (commentText) => {
			if (commentTextLength(commentText) > 14) {
				return true;
			}
			return false;
		};

		/**
		 * Validates comment author name,
		 * and renders error message when needed.
		 *
		 * @param {Object} name input element for comment author name
		 * @return {boolean} true when name is valid, otherwise false
		 */
		const isValidCommentName = (name) => {
			// bail out early when the comment author name field is not on the page
			// that would occur normally when user is logged in
			if (!inputElementExists(name)) {
				return true; // no error if input does not exist
			}
			if (isEmptyInput(name)) {
				setMessage('name', getMessage('name', 'required'));
				return false;
			}
			setMessage('name', '');
			return true;
		};

		/**
		 * Validates comment author email address
		 * and renders error message when needed.
		 *
		 * @param {Object} email input element for comment author's email address
		 * @return {boolean} true when email is valid, otherwise false
		 */
		const isValidCommentEmail = (email) => {
			// Bail out early when the email field is not present on the page.
			// That would occur normally when user is logged in.
			if (!inputElementExists(email)) {
				return true; // no error when e-mail input doesn't exist
			}
			if (isEmptyInput(email)) {
				setMessage('email', getMessage('email', 'required'));
				return false;
			} else if (!isValidEmailAddressFormat(email)) {
				setMessage('email', getMessage('email', 'invalid'));
				return false;
			}
			setMessage('email', '');
			return true;
		};

		/**
		 * Validate comment content area and render error messages.
		 *
		 * @param {*} commentText textarea element for comment content
		 * @return {boolean} true when comment text is valid, otherwise false
		 */
		const isValidCommentText = (commentText) => {
			// Bail out early when the comment text field is not on the page.
			// Normally this shouldn't happen, since when a page
			// doesn't allow comments, this script isn't loaded.
			// However there where cases where cpt's or pages had comments on,
			// but didn't render the comments section. So just in case...
			if (!inputElementExists(commentText)) {
				return true; // no error if input does not exist
			}

			const minLength = 15;
			const shortage = minLength - commentTextLength(commentText);
			if (isEmptyInput(commentText)) {
				setMessage(
					'comment',
					getMessage('comment', 'required').replace('%d', minLength)
				);
				return false;
			}
			if (!isCommentTextLongEnough(commentText)) {
				setMessage(
					'comment',
					getMessage('comment', 'too short').replace('%d', shortage)
				);
				return false;
			}
			setMessage('comment', '');
			return true;
		};

		/**
		 * Enables submit button when all form inputs are correct based on the parameter.
		 * Shows message and disables submit button when all input is not yet well.
		 *
		 * @param {boolean} allIsWell true/false indication that lets function know all form inputs are correct
		 * @return {void}
		 */
		const setCommentSubmitButton = (allIsWell) => {
			if (allIsWell) {
				enableButton(comment.submitButton.button);
				setMessage('form', '');
				return;
			}
			disableButton(comment.submitButton.button);
			setMessage('form', getMessage('form', 'incomplete'));
		};

		/**
		 * Checks the inputs and render error messages if needed.
		 *
		 * @return {boolean} false when comment form input is insuffiecient or incorrect
		 */
		const isValidCommentFormInput = () => {
			let allIsWell;

			/**
			 * Checks all input-fields and build allIsWell.
			 */
			allIsWell = isValidCommentName(comment.name.input);
			allIsWell = isValidCommentEmail(comment.email.input) && allIsWell;
			allIsWell = isValidCommentText(comment.text.input) && allIsWell;
			setCommentSubmitButton(allIsWell);
			return allIsWell;
		};

		/**
		 * Adds an element below comment author name,
		 * where error messages about author name input can be shown.
		 *
		 * @return {void}
		 */
		const addAuthorNameErrorMessageContainer = () => {
			$('.comment-form-author').append('<span id="nameNotice"></span>');
		};

		/**
		 * Adds an element below comment author email,
		 * where error messages about author email input can be shown.
		 *
		 * @return {void}
		 */
		const addEmailErrorMessageContainer = () => {
			$('.comment-form-email').append('<span id="emailNotice"></span>');
		};

		/**
		 * Adds an element below the comment textarea,
		 * where error messages about the comment content can be shown.
		 *
		 * @return {void}
		 */
		const addCommentTextErrorMessageContainer = () => {
			$('.comment-form-comment').append(
				'<span id="commentNotice"></span>'
			);
		};

		/**
		 * Adds an element below the comment's submit button,
		 * where an explaination message can be shown
		 * to alert the user on that the button will be enabled
		 * after the form is correctly filled out.
		 *
		 * @return {void}
		 */
		const addSubmitButtonErrorMessageContainer = () => {
			$('.form-submit').append('<p id="pleaseFillForm"></p>');
		};

		/**
		 * Initializes the comment form validation by adding elements for error messages
		 * and performs first validation to initialize the messages.
		 *
		 * @return {void}
		 */
		const addCommentFormMessageContainers = () => {
			/**
			 * Add elements to show error messages in.
			 */
			addAuthorNameErrorMessageContainer();
			addEmailErrorMessageContainer();
			addCommentTextErrorMessageContainer();
			addSubmitButtonErrorMessageContainer();
		};

		/**
		 * Determines the existence of a DOM element.
		 *
		 * Since jquery always returns an jQuery object for a selection
		 * we have to check the length (number of elements in the jQ object)
		 * to determine if an element was selected.
		 *
		 * Length 0 indicates there were no elements with the selector.
		 *
		 * @param {Object} input jQuery object to check for containing elements
		 * @return {boolean} true if one or more element exist, otherwise false
		 */
		const inputElementExists = (input) => {
			if (input.length > 0) {
				return true;
			}
			return false;
		};

		/*
		 * Add container that will be used to display messages.
		 */
		addCommentFormMessageContainers();
		/**
		 * Perform initial validations.
		 */
		isValidCommentFormInput();
		/**
		 * Update notices while fields are edited.
		 * Submit button will be enabled when all input checks out.
		 */
		$('#commentform').keyup(function () {
			isValidCommentFormInput();
		});
	});
})(jQuery, document);
